module.exports = __webpack_public_path__ + "6eb4672568e60d4814dbdf171d004ef0.pdf";